/**
 * 检测信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 接口地址   /api/v1/auctions/{auction_id}/inspections
Mock.mock(/\/auctions\/\d+\/inspections/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_id': 1, // 拍卖活动ID
    'inspections': {
      'head': [
        {
          'id': 2,
          'damageList': [
            {
              'key': '2',
              'value': '刮伤',
              'selected': true
            }
          ],
          'note': '左前大灯',
          'title': [
            '刮伤'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ]
        },
        {
          'id': 3,
          'damageList': [
            {
              'key': '2',
              'value': '刮伤',
              'selected': true
            },
            {
              'key': '3',
              'value': '水雾',
              'selected': true
            }
          ],
          'note': '右前大灯',
          'title': [
            '刮伤',
            '水雾'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 4,
          'damageList': [
            {
              'key': '2',
              'value': '修复痕迹',
              'selected': true
            },
            {
              'key': '3',
              'value': '变形',
              'selected': true
            },
            {
              'key': '4',
              'value': '淤泥痕迹',
              'selected': true
            }
          ],
          'note': '前横梁',
          'title': [
            '修复痕迹',
            '变形',
            '淤泥痕迹'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 5,
          'damageList': [
            {
              'key': '2',
              'value': '修复痕迹',
              'selected': true
            },
            {
              'key': '5',
              'value': '更换过',
              'selected': true
            },
            {
              'key': '6',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '水箱支架',
          'title': [
            '修复痕迹',
            '更换过',
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': '898989'
        },
        {
          'id': 6,
          'damageList': [
            {
              'key': '3',
              'value': '纵梁变形',
              'selected': true
            },
            {
              'key': '5',
              'value': '梁头更换',
              'selected': true
            },
            {
              'key': '7',
              'value': '梁头修复痕迹',
              'selected': true
            },
            {
              'key': '8',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '左前纵梁',
          'title': [
            '纵梁变形',
            '梁头更换',
            '梁头修复痕迹',
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 7,
          'damageList': [
            {
              'key': '5',
              'value': '梁头更换',
              'selected': true
            },
            {
              'key': '6',
              'value': '梁头变形',
              'selected': true
            }
          ],
          'note': '右前纵梁',
          'title': [
            '梁头更换',
            '梁头变形'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 9,
          'damageList': [
            {
              'key': '3',
              'value': '变形',
              'selected': true
            },
            {
              'key': '5',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '右前避震器座',
          'title': [
            '变形',
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': '哇快快快快乐乐'
        }
      ],
      'left': [
        {
          'id': 15,
          'damageList': [
            {
              'key': '6',
              'value': '漆面色差',
              'selected': true
            }
          ],
          'note': '左前叶子板',
          'title': [
            '漆面色差'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 17,
          'damageList': [
            {
              'key': '2',
              'value': '轻微刮伤',
              'selected': true
            },
            {
              'key': '5',
              'value': '改装',
              'selected': true
            }
          ],
          'note': '左前轮胎',
          'title': [
            '轻微刮伤',
            '改装'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 20,
          'damageList': [
            {
              'key': '2',
              'value': '喷漆修复',
              'selected': true
            },
            {
              'key': '6',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '左A柱',
          'title': [
            '喷漆修复',
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': '88888'
        },
        {
          'id': 23,
          'damageList': [
            {
              'key': '2',
              'value': '喷漆修复',
              'selected': true
            },
            {
              'key': '3',
              'value': '钣金修复',
              'selected': true
            },
            {
              'key': '4',
              'value': '焊接痕迹',
              'selected': true
            }
          ],
          'note': '左C柱',
          'title': [
            '喷漆修复',
            '钣金修复',
            '焊接痕迹'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        }
      ],
      'right': [
        {
          'id': 36,
          'damageList': [
            {
              'key': '3',
              'value': '严重划痕(见底漆)',
              'selected': true
            },
            {
              'key': '8',
              'value': '喷漆修复',
              'selected': true
            }
          ],
          'note': '右后叶子板',
          'title': [
            '严重划痕(见底漆)',
            '喷漆修复'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 37,
          'damageList': [
            {
              'key': '1',
              'value': '正常',
              'selected': true
            }
          ],
          'note': '右后轮毂',
          'title': [
            '正常'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 38,
          'damageList': [
            {
              'key': '2',
              'value': '轻微刮伤',
              'selected': true
            }
          ],
          'note': '右后轮胎',
          'title': [
            '轻微刮伤'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 39,
          'damageList': [
            {
              'key': '9',
              'value': '锈蚀',
              'selected': true
            }
          ],
          'note': '右后门',
          'title': [
            '锈蚀'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 40,
          'damageList': [
            {
              'key': '4',
              'value': '焊接痕迹',
              'selected': true
            }
          ],
          'note': '右C柱',
          'title': [
            '焊接痕迹'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 41,
          'damageList': [
            {
              'key': '3',
              'value': '钣金修复',
              'selected': true
            }
          ],
          'note': '右B柱',
          'title': [
            '钣金修复'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 42,
          'damageList': [
            {
              'key': '11',
              'value': '更换过',
              'selected': true
            }
          ],
          'note': '右前门',
          'title': [
            '更换过'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 43,
          'damageList': [
            {
              'key': '6',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '右A柱',
          'title': [
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': '324242'
        },
        {
          'id': 44,
          'damageList': [
            {
              'key': '3',
              'value': '严重划痕(见底漆)',
              'selected': true
            }
          ],
          'note': '右后视镜',
          'title': [
            '严重划痕(见底漆)'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 47,
          'damageList': [
            {
              'key': '5',
              'value': '改装',
              'selected': true
            }
          ],
          'note': '右前轮胎',
          'title': [
            '改装'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        }
      ],
      'tail': [
        {
          'id': 28,
          'damageList': [
            {
              'key': '3',
              'value': '水雾',
              'selected': true
            }
          ],
          'note': '左后大灯',
          'title': [
            '水雾'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 29,
          'damageList': [
            {
              'key': '4',
              'value': '破损裂痕',
              'selected': true
            }
          ],
          'note': '右后大灯',
          'title': [
            '破损裂痕'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 30,
          'damageList': [
            {
              'key': '7',
              'value': '漆面爆裂',
              'selected': true
            }
          ],
          'note': '后行李箱盖',
          'title': [
            '漆面爆裂'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 31,
          'damageList': [
            {
              'key': '3',
              'value': '严重划痕(见底漆)',
              'selected': true
            }
          ],
          'note': '后保险杠',
          'title': [
            '严重划痕(见底漆)'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 32,
          'damageList': [
            {
              'key': '5',
              'value': '其他',
              'selected': true
            }
          ],
          'note': '后挡风玻璃',
          'title': [
            '其他'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': '952'
        },
        {
          'id': 33,
          'damageList': [
            {
              'key': '5',
              'value': '修复痕迹',
              'selected': true
            }
          ],
          'note': '备胎',
          'title': [
            '修复痕迹'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 34,
          'damageList': [
            {
              'key': '3',
              'value': '缺三角警示牌',
              'selected': true
            }
          ],
          'note': '随车工具',
          'title': [
            '缺三角警示牌'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 35,
          'damageList': [
            {
              'key': '2',
              'value': '修复痕迹',
              'selected': true
            },
            {
              'key': '4',
              'value': '锈蚀',
              'selected': true
            },
            {
              'key': '5',
              'value': '水渍或泥沙',
              'selected': true
            }
          ],
          'note': '备胎室',
          'title': [
            '修复痕迹',
            '锈蚀',
            '水渍或泥沙'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        }
      ],
      'machine_interior': [
        {
          'id': 51,
          'damageList': [
            {
              'key': '3',
              'value': '漏油',
              'selected': true
            }
          ],
          'note': '转向机',
          'title': [
            '漏油'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 54,
          'damageList': [
            {
              'key': '4',
              'value': '破损',
              'selected': true
            }
          ],
          'note': '座椅',
          'title': [
            '破损'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 62,
          'damageList': [
            {
              'key': '2',
              'value': '有泥沙',
              'selected': true
            },
            {
              'key': '3',
              'value': '有更换过',
              'selected': true
            }
          ],
          'note': '保险盒',
          'title': [
            '有泥沙',
            '有更换过'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 63,
          'damageList': [
            {
              'key': '2',
              'value': '有水渍或泥沙',
              'selected': true
            }
          ],
          'note': 'EUC接口处',
          'title': [
            '有水渍或泥沙'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 64,
          'damageList': [
            {
              'key': '2',
              'value': '有锈迹',
              'selected': true
            }
          ],
          'note': '点烟器底座',
          'title': [
            '有锈迹'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 66,
          'damageList': [
            {
              'key': '2',
              'value': '有霉味',
              'selected': true
            }
          ],
          'note': '驾驶舱和后备箱',
          'title': [
            '有霉味'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 67,
          'damageList': [
            {
              'key': '2',
              'value': '有水渍或泥沙',
              'selected': true
            }
          ],
          'note': '后排座椅座垫底部',
          'title': [
            '有水渍或泥沙'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 68,
          'damageList': [
            {
              'key': '2',
              'value': '有火烧或烟熏',
              'selected': true
            }
          ],
          'note': '发动机线束及橡胶制品',
          'title': [
            '有火烧或烟熏'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        },
        {
          'id': 69,
          'damageList': [
            {
              'key': '2',
              'value': '有火烧或烟熏',
              'selected': true
            }
          ],
          'note': '车辆覆盖件及驾驶舱',
          'title': [
            '有火烧或烟熏'
          ],
          'images': [
            {
              'position': '1',
              'image_url': '',
              'delIcon': false,
              'position_code': 'first'
            },
            {
              'position': '2',
              'image_url': '',
              'delIcon': false,
              'position_code': 'second'
            },
            {
              'position': '3',
              'image_url': '',
              'delIcon': false,
              'position_code': 'third'
            },
            {
              'position': '4',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fourth'
            },
            {
              'position': '5',
              'image_url': '',
              'delIcon': false,
              'position_code': 'fifth'
            },
            {
              'position': '6',
              'image_url': '',
              'delIcon': false,
              'position_code': 'sixth'
            }
          ],
          'message': ''
        }
      ],
      'appliance': []
    }
  }
})
